import { takeEvery, call, put, select, race, delay } from 'redux-saga/effects'
import { getTenderChildren } from '../../lib/requests/routesRequests'
import { delays } from '../../lib/constants'
import { getCurrentLang, getToken, getDicionary } from '../selectors'

export function* worker({ periodic }) {
  try {
    const currentLang = yield select(getCurrentLang)
    const token = yield select(getToken)
    const dic = yield select(getDicionary)

    yield put({
      type: 'SET_TENDER_CHILDREN_LOADER',
      payload: true,
    })

    const { result } = yield race({
      result: call(getTenderChildren, token, currentLang, periodic),
      timeout: delay(delays.forCancelRequest),
    })

    if (result && result.status === 200) {
      yield put({
        type: 'SET_TENDER_CHILDREN',
        payload: result.data.data,
      })

      yield put({
        type: 'SET_TENDER_CHILDREN_LOADER',
        payload: false,
      })

    } else {
      yield put({
        type: 'SHOW_ERROR_API',
        code: 6,
        message: dic.msg_server_err || 'internal server error',
      })
      yield put({
        type: 'SET_TENDER_CHILDREN_LOADER',
        payload: false,
      })
    }
  } catch (e) {
    yield put({
      type: 'SET_API_ERROR',
      payload: true,
    })

    yield put({
      type: 'SET_TENDER_CHILDREN_LOADER',
      payload: false,
    })
    yield put({
      type: 'SHOW_ERROR_API',
      code: String(e.response.status).slice(0, 1),
      message: e.response ? e.response.data.message : e.message,
    })
    if (e.response && e.response.data.relogin) {
      yield put({ type: 'SAGA_LOGOUT' })
    }
    if (e.response && e.response.data.forwardTo) {
      yield put({
        type: 'REDIRECT_OUTSIDE',
        payload: e.response.data.forwardTo,
      })
    }
  }
}

export default function* singleTender() {
  yield takeEvery('SAGA_GET_TENDER_CHILDREN', worker)
}
